import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './EvaluationLinksView.css'
import axios from 'axios';

import FooterLanding from '../../components/footerLanding/footerLanding';
import StepCompetencesEvaluation from '../../components/stepCompetencesEvaluation/stepCompetencesEvaluation';
import { apiUrl } from '../../utility/Connections';
import { Layout, Modal, Input, message, Typography } from 'antd';
import StepCompetencesEvaluationDesc from '../../components/stepCompetencesEvaluationDesc/stepCompetencesEvaluationDesc';
import HeaderEvaluation from '../../components/headerEvaluation/headerEvaluation';
import LoadingOverlay from '../../components/loadingOverlay/loadingOverlay';
import TableUserLinks from '../../components/tableUserLinks/tableUserLinks';

const { Content } = Layout;
const { Text } = Typography;

const EvaluationLinksView = () => {
    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("");
    const [relationShipsData, setRelationshipsData] = useState(null);
    const [orgLogo, setOrgLogo] = useState(null);

    const [dni, setDni] = useState("");
    const [showModal, setShowModal] = useState(true); 

    const { evlid } = useParams();
    const { useremail } = useParams();

    const getEvaluationRelationshipsByUser = (dni) => {
        setLoadingText("Consultando información...");
        setShowLoading(true);

        axios.post(`${apiUrl}/evaluation-relationships/get-evaluation-relationships-by-user/`, {
            dni: dni,
            email: useremail,
            evl_id: evlid
        }).then(response => {
            const data = response.data.data;
            setRelationshipsData(data);
            getOrganizationLogo(data.org_id);
        }).catch(error => {
            console.error('Error al obtener relaciones:', error);
            message.error("No se encontró ninguna relaciones para los datos ingresados.");
            setShowLoading(false);
        });
    };

    const getOrganizationLogo = (orgId) => {
        axios.get(`${apiUrl}/organizations/get-organization-logo/${orgId}/`)
            .then(function (response) {
                const data = response.data.org_logo;
                setOrgLogo(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    return <div className='login-view-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Layout style={{ width: "100vw" }}>
            <HeaderEvaluation orgLogo={orgLogo} />
            <Content
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    backgroundColor: 'white',
                    // backgroundColor: '#3E246B',
                    padding: 24,
                    width: "100vw",
                    height: "calc(100vh - 64px)",
                    overflowY: 'auto',
                    position: 'relative',
                }}
            >
                <TableUserLinks data={relationShipsData} />
            </Content>
            <FooterLanding />
        </Layout>

        <Modal
            title="Validación de identidad"
            visible={showModal}
            closable={false}
            maskClosable={false}
            okText="Ingresar"
            onOk={() => {
                if (!dni || dni.trim() === "") {
                    message.error("Por favor, ingrese su número de documento");
                    return;
                }
                setShowModal(false);
                getEvaluationRelationshipsByUser(dni.trim());
            }}
            cancelButtonProps={{ style: { display: 'none' } }}
        >
            <p>Ingrese su número de documento de identidad para continuar:</p>
            <Input
                placeholder="Número de documento"
                value={dni}
                onChange={(e) => setDni(e.target.value)}
                onPressEnter={() => {
                    if (!dni || dni.trim() === "") {
                        message.error("Por favor, ingrese su número de documento");
                        return;
                    }
                    setShowModal(false);
                    getEvaluationRelationshipsByUser(dni.trim());
                }}
            />
        </Modal>
    </div>
}

export default EvaluationLinksView;